module.exports = __webpack_public_path__ + "static/img/200267.7c7e6a06.png";